import {StructuredDataContent} from 'rlink-repos/content';

export default class HomePage extends StructuredDataContent {
  get adminLabel() {
    return "Home Page";
  }

  static get isAdministrative() {
    return true;
  }

  static get path() {
    return "/content/home-page.json";
  }

  static get(repo) {
    return this.fetchOrMakeFromPath(repo, this.path, {
    })
  }

  get studioCopy() {
    return this.data.get('studioCopy', '')
  }

  get careersCopy() {
    return this.data.get('careersCopy', '')
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/HomePage.js